import { render, staticRenderFns } from "./InviteStatus.vue?vue&type=template&id=72689f73&scoped=true&"
import script from "./InviteStatus.vue?vue&type=script&lang=js&"
export * from "./InviteStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72689f73",
  null
  
)

export default component.exports